'use client';

import { useEffect, useRef } from 'react';
import Parallax from 'parallax-js';
import QuestionMark from './QuestionMark';

export default function QuestionMarkParallax({
  size = 'h-[220px]',
  position = 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
}: {
  size?: string;
  position?: string;
}) {
  const sceneRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sceneRef.current) return;
    const parallax = new Parallax(sceneRef.current, {
      limitX: 90,
      limitY: 90,
    });
    return () => parallax.disable();
  }, []);

  return (
    <div
      ref={sceneRef}
      aria-hidden
      className='pointer-events-none absolute inset-0 -z-10 overflow-visible'
    >
      <div data-depth='0.3' className={`absolute ${position} text-fg/3`}>
        <QuestionMark className={`${size} w-auto`} />
      </div>
    </div>
  );
}
